module.exports = __webpack_public_path__ + "static/media/54_1141.0f67e2d0.webp";